const mobileDetect = () => {

    const mq = window.matchMedia('(min-width: 48rem)');
    return !mq.matches;

}

export default mobileDetect;